import { safeDeleteSheet } from "@/lib/office-helpers";

export async function startProject13(): Promise<void> {
  await Excel.run(async (context) => {
    const sheetName = "Lista de precios";
    const workbookNames = context.workbook.names;
    workbookNames.load("items/name");
    await context.sync();

    const namesToDelete = new Set([
      "precio_10g",
      "instalación_10g",
      "soporte_10g",
      "precios",
    ]);

    for (const nameItem of workbookNames.items) {
      if (namesToDelete.has(nameItem.name.toLowerCase())) {
        nameItem.delete();
      }
    }
    await context.sync();

    await safeDeleteSheet(context, sheetName);

    const sheet = context.workbook.worksheets.add(sheetName);

    sheet.getRange("B2:F2").merge();
    sheet.getRange("B2").values = [["Lista de precios del hardware de red"]];
    sheet.getRange("B2").format.horizontalAlignment = "Center";
    sheet.getRange("B2").format.font.size = 18;
    sheet.getRange("B2").format.font.color = "#4FACC9";
    sheet.getRange("B2").format.font.bold = false;

    const headersCableado = [
      "# Art\u00EDculo",
      "Equipo al\u00E1mbrico",
      "Tama\u00F1o del puerto",
      "Precio",
      "Instalaci\u00F3n",
      "Soporte",
    ];

    const datosCableado: (string | number)[][] = [
      [5847, "Firewall del hardware de red", "", 5180, 500, 500],
      [5535, "Server Rack", "16-slot", 2780, 300, 200],
      [7859, "Server Rack", "32-slot", 4940, 300, 200],
      [9220, "Switch Ethernet 10/100", "4-port", 10, 10, 20],
      [12343, "Switch Ethernet 10/100/1000", "8-port", 60, 10, 30],
      [2356, "Router de 10 Gbps", "24-port", 4940, 300, 400],
      [3745, "Router de 10 Gbps", "8-port", 3020, 300, 400],
      [4687, "Router de 10 Gbps", "16-port", 3880, 300, 400],
      [2356, "Router de 10 Gbps", "24-port", 4940, 300, 400],
      [2356, "Router de 10 Gbps", "24-port", 4940, 300, 400],
      [7789, "Kit de prensado y ponchado", "", 100, 0, 0],
    ];

    const headersInalambrico = [
      "# Art\u00EDculo",
      "Equipo inal\u00E1mbrico",
      "Tama\u00F1o de banda",
      "Precio",
      "Instalaci\u00F3n",
      "Soporte",
    ];

    const datosInalambrico: (string | number)[][] = [
      [8587, "Montaje universal en techo", "", 6220, 8290, 6630],
      [7896, "Detector de se\u00F1al inal\u00E1mbrico", "", 10125, 13500, 10800],
      [3578, "Detector de colisi\u00F3n IEEE 802.11", "", 11250, 15000, 12000],
      [7418, "Punto de acceso inal\u00E1mbrico A/B/G/N", "\u00DAnico", 3240, 4320, 3450],
      [5296, "Punto de acceso inal\u00E1mbrico A/B/G/N", "Doble", 3345, 4460, 3570],
      [3741, "Extensor de punto de acceso inal\u00E1mbrico", "\u00DAnico", 3625, 4830, 3865],
      [8529, "Punto de acceso inal\u00E1mbrico A/B/G/N/Ae", "Doble", 4660, 6210, 4970],
      [6396, "Punto de acceso inal\u00E1mbrico A/B/G/N/Ae", "Doble", 5925, 7900, 6320],
      [7411, "Extensor de punto de acceso inal\u00E1mbrico", "Doble", 5925, 7900, 6320],
    ];

    const tablaCableado = sheet.tables.add("A4:F4", true);
    tablaCableado.name = "Alambrico";
    tablaCableado.getHeaderRowRange().values = [headersCableado];
    tablaCableado.rows.add(undefined, datosCableado);
    tablaCableado.style = "TableStyleMedium16";

    const tablaInalambrico = sheet.tables.add("A17:F17", true);
    tablaInalambrico.name = "Inalambrico";
    tablaInalambrico.getHeaderRowRange().values = [headersInalambrico];
    tablaInalambrico.rows.add(undefined, datosInalambrico);
    tablaInalambrico.style = "TableStyleMedium16";

    sheet.getRange("H4:I4").merge();
    sheet.getRange("H4").values = [[
      "Valor de enrutadores de 10 Gbps\ncon instalaci\u00F3n y soporte",
    ]];
    sheet.getRange("H4:I4").format.wrapText = true;
    sheet.getRange("H4:I4").format.horizontalAlignment = "Left";
    sheet.getRange("H4:I4").format.verticalAlignment = "Center";
    sheet.getRange("H4:I4").format.fill.color = "#4FACC9";
    sheet.getRange("H4:I4").format.font.color = "#FFFFFF";
    sheet.getRange("H4:I4").format.font.bold = true;

    sheet.getRange("H5:I5").merge();
    sheet.getRange("H5:I5").format.horizontalAlignment = "Center";
    sheet.getRange("H5:I5").format.verticalAlignment = "Center";

    sheet.getRange("D5:F26").numberFormat = Array(22).fill(["0", "0", "0"]);

    sheet.getRange("A:A").format.columnWidth = 80;
    sheet.getRange("B:B").format.columnWidth = 220;
    sheet.getRange("C:C").format.columnWidth = 90;
    sheet.getRange("D:F").format.columnWidth = 80;
    sheet.getRange("H:H").format.columnWidth = 120;
    sheet.getRange("I:I").format.columnWidth = 120;
    sheet.getRange("4:4").format.rowHeight = 42;
    sheet.getRange("17:17").format.rowHeight = 42;

    const cfRange = sheet.getRange("F18:F26");
    const conditional = cfRange.conditionalFormats.add(
      Excel.ConditionalFormatType.dataBar
    );
    conditional.dataBar.barDirection =
      Excel.ConditionalDataBarDirection.leftToRight;
    conditional.dataBar.lowerBoundRule = {
      formula: "0",
      type: Excel.ConditionalFormatRuleType.number,
    };
    conditional.dataBar.upperBoundRule = {
      type: Excel.ConditionalFormatRuleType.highestValue,
    };
    conditional.dataBar.positiveFormat.fillColor = "#F5A623";
    conditional.dataBar.positiveFormat.borderColor = "#F5A623";
    conditional.dataBar.positiveFormat.gradientFill = true;
    conditional.dataBar.showDataBarOnly = false;

    context.workbook.names.add("Precio_10G", `='${sheetName}'!$D$10:$D$14`);
    context.workbook.names.add(
      "Instalaci\u00F3n_10G",
      `='${sheetName}'!$E$10:$E$14`
    );
    context.workbook.names.add("Soporte_10G", `='${sheetName}'!$F$10:$F$14`);

    sheet.activate();
    sheet.getRange("A1").select();

    await context.sync();
  });
}
